import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import moment from 'moment';
import { debounce, isEmpty } from 'lodash';
import { bob, k2aCore } from '../../../data/tabs';

import HealthMonitorTable from '../HealthMonitorTable/HealthMonitorTable';
import ScoringPage from './ScoringPage/ScoringPage';
import EquipmentTable from './EquipmentTable';
import SystemsTable from './SystemsTable';
import BobActionMenu from '../../../components/BobActionMenu';
import BobModal from '../../../components/BobModal';
import FilterChip from '../../../components/FilterChip';
import BobFilterComponent from '../../../components/BobFilterComponent';
import ContactsTable from '../Contacts/ContactsTable';
import ContactsTableActionMenu from '../Contacts/ContactsTableActionMenu';

import { getActiveTabName } from '../Navigation/NavigationHelper';
import SearchInput from '../../Global/SearchInput';
import TotalsPanel from '../../../components/TotalsPanel';
import TabViewSelector from '../../../components/TabViewSelector';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';
import ExportDataModal from '../Modals/ExportDataModal';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';
import { getTimeZoneAbbr } from '../../../helpers/timezones';
import FaultsTable from './FaultsTable';

import queryString from 'query-string';

import { withRouter } from 'react-router-dom';

import { dashboardContent } from '../../../localization/en-us/dashboardContent';

import {
    renderChip,
    renderFilter,
    removeFilter
} from '../../../helpers/tableContainerHelper';

import * as ContactActions from '../../../actions/contactActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as WeatherActions from '../../../actions/weatherActions';


import classes from './TableContainer.module.css';
import { setPageTitle } from '../../../helpers/auth';
import PreviewWeatherDataModal from '../Modals/PreviewWeatherDataModal';

const TABNAMES = {
    'Equipment': dashboardContent.equipment,
    'Faults':    dashboardContent.faults,
    'System':    dashboardContent.systems,
    'Scoring':   dashboardContent.scoring
};

const TableContainer = ({
    activeNavCompany,
    activeNavClient,
    activeNavSite,
    bulkDeleteContact,
    cardScores,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    equipmentFilters,
    equipmentTypes,
    exportTableData,
    exportTimeSeriesData,
    fetchCurrentWeatherData,
    fetchSiteContacts,
    history,
    healthMonitorFilters,
    issueTypes,
    isShowExportModal,
    setEquipmentFilters,
    setSystemFilters,
    setWorkBookMode,
    setHealthMonitorFilters,
    siteEquipment,
    siteEquipmentMeta,
    siteFaultSummaryMeta,
    siteSystems,
    siteSystemsMeta,
    systemFilters,
    systemTypes,
    workbookModeEnabled,
    ...props
}) => {
    const [createEquipmentModalOpen, handleToggleCreateEquipmentModal] = useState(false);
    const [deleteSystemModalOpen, handleToggleDeleteSystemModal] = useState(false);
    const [deleteEquipmentModalOpen, handleToggleDeleteEquipmentModal] = useState(false);
    const [subscribeToAlertsEqquipmentModalOpen, handleToggleSubscribeToEquipmentAlertsModal] = useState(false);
    const [subscribeToAlertsSystemsModalOpen, handleToggleSubscribeToSystemsAlertsModal] = useState(false);
    const [subscribeToAreaModalOpen, setSubscribeToAreaModalOpen] = useState(false);
    const [subscribeToRuleAlertsModalOpen, setSubscribeToRuleAlertsModalOpen] = useState(false);
    const [previewWeatherDataModalOpen, setPreviewWeatherDataModalOpen] = useState(false);

    const [equipmentTableProps, setEquipmentTableProps] = useState({});
    const [systemTableProps, setSystemTableProps] = useState({});
    const [contactTableSelectState, setContactTableSelectState] = useState({});

    const [activeTab, setActiveTab] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const [exportSiteEquipment, setExportSiteEquipment] = useState(false);
    const [exportFaultView, setExportFaultView] = useState(false);
    const [refreshTab, setRefreshTab] = useState('');
    const [exportColumns, setExportColumns] = useState([]);
    const _export = React.useRef(null);
    const _contactExport = React.useRef(null);

    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [isexportNodeHealthChecks, setIsexportNodeHealthChecks] = useState(false);

    useEffect(() => {
        if (activeNavSite.name) {
            setPageTitle(activeNavSite.name, activeTab);
        }
    }, [activeNavSite.name]);

    useEffect(() => {
        const { pathname } = history.location;
        const queryValues = queryString.parse(history.location.search);
        
        let key = queryValues.appId;
            
        if ( queryValues.parentId ) {
            key = queryValues.parentId;
        }

        if ( queryValues.childId ) {
            key = queryValues.childId;
        }

        let activetab = getActiveTabName(key);
        if (activeNavSite.name) {
            setPageTitle(activeNavSite.name, activetab);
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValuesString}`);
        setSearchTerm('');
        setTimeout(() => {
            setActiveTab(activetab);
        }, 100);
    }, [history.location.search]);

    const getActiveTabTableProps = () => {
        let tableProps = {};
        if (activeTab === 'Equipment') {
            tableProps = equipmentTableProps;
        } else if (activeTab === 'System') {
            tableProps = systemTableProps;
        }

        return tableProps;
    };

    const handleExport = event => {
        setExportModalOpen(true);
    };

    const handleExcelExport = event => {
        if (activeTab === 'Faults') {
            setExportFaultView(true);
        }
        else {
            setExportSiteEquipment(true);
        }
    };

    const handleExportTimeseries = event => {
        const zone = moment.tz.guess();
        const tzOffset = moment.tz.zone(zone).utcOffset(moment(dashboardEndTimeStamp)) * -1;
        const queryValues = queryString.parse(history.location.search);
        let tableProps = {};

        if (activeTab === 'Equipment') {
            tableProps = equipmentTableProps;
        } else if (activeTab === 'System') {
            tableProps = systemTableProps;
        }

        exportTimeSeriesData(`Site${TABNAMES[activeTab]}`, queryValues, tableProps, { from: dashboardStartTimeStamp, to: dashboardEndTimeStamp, timediff: tzOffset });
    };

    const handleHealthMonitorExport = event => {
        const statusColumn = exportColumns.findIndex(c => c.field === 'status');
        const priorityColumn = exportColumns.findIndex(c => c.field === 'priority');
        const issueTypeColumn = exportColumns.findIndex(c => c.field === 'issueTypes');
        const equipmentSystemColumn = exportColumns.findIndex(c => c.field === 'equipmentSystem');
        const routeColumn = exportColumns.findIndex(c => c.field === 'snapshotRoute');
        const faultTimestampColumn = exportColumns.findIndex(c => c.field === 'faulttimestamp');
        const options = _export.current.workbookOptions();
        const rows = options.sheets[0].rows;
        rows.forEach(row => {
            if (row.type === 'data') {
                const statusCell = row.cells[statusColumn];
                const priorityCell = row.cells[priorityColumn];
                const issueTypeCell = row.cells[issueTypeColumn];
                const routeCell = row.cells[routeColumn];
                const equipmentSystemCell = row.cells[equipmentSystemColumn];
                const faultTimestampCell = row.cells[faultTimestampColumn];
                equipmentSystemCell.value = routeCell.value.substring(routeCell.value.lastIndexOf('/') + 1);
                statusCell.value = statusCell.value.toString().toLowerCase() === 'true' ? 'Fault' : 'OK';
                priorityCell.value = priorityCell.value === 0 ? 'Low' : priorityCell.value === 1 ? 'Medium' : 'High';
                issueTypeCell.value = issueTypeCell.value.join(', ');
                faultTimestampCell.value = faultTimestampCell.value ? moment(faultTimestampCell.value).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(faultTimestampCell.value), moment.tz.guess()) : null;
            }
        });
        _export.current.save(options);
    };

    const healthMonitorRawDataExport = event => {
        setIsexportNodeHealthChecks(true);
    };
    
    const renderTotalsData = activeTab => {
        switch (activeTab) {
            case 'Equipment':
                return siteEquipmentMeta;
            case 'System':
                return siteSystemsMeta;
            case 'Health Monitor':
                return cardScores;
            case 'Faults':
                return siteFaultSummaryMeta;
            default:
                return;
        }
    };

    const renderSelectData = activeTab => {
        switch (activeTab) {
            case 'Equipment':
                return equipmentTypes;
            case 'System':
                return systemTypes;
            case 'Health Monitor':
                return issueTypes;
            default:
                return [];
        }
    };

    const renderLabel = activeTab => {
        // Both case 0 (equipment) and case 1 (system) use
        // equipment type to describe the entity.
        switch (activeTab) {
            case 'Equipment':
                return 'Equipment Types';
            case 'System':
                return 'System Types';
            case 'Health Monitor':
                return 'Issue Types';
            default:
                return '';
        }
    };

    const selectSetFilter = activeTab => {
        switch (activeTab) {
            case 'Equipment':
                return setEquipmentFilters;
            case 'System':
                return setSystemFilters;
            case 'Health Monitor':
                return setHealthMonitorFilters;
            default:
                return;
        }
    };

    const handleSetFilter = activeTab => {
        return selectSetFilter(activeTab);
    };
    
    const activeFilters = {
        'Equipment':      equipmentFilters,
        'System':         systemFilters,
        'Health Monitor': healthMonitorFilters
    };

    const renderActiveFilters = activeTab => {
        let filters = activeFilters[activeTab] || {};

        return renderFilter(filters);
    };

    const renderChips = activeTab => {
        let filters = activeFilters[activeTab] || {};

        if (isEmpty(filters)) return [];

        return renderChip(filters);
    };

    const handleRemoveFilter = (activeTab, item) => {
        const setFilters = selectSetFilter(activeTab);
        let filters = activeFilters[activeTab];

        removeFilter(setFilters, filters, item);
    };

    const handleChangetabView = (tabView) => {
        const queryValues = queryString.parse(history.location.search);
        let childId = '';

        const { pathname } = history.location;

        if ( tabView.viewParentId ) {
            childId = tabView.viewParentId;
            const viewChildId = tabView.key;

            queryValues.viewChildId = viewChildId;
        } else {
            childId = tabView.key;
        }

        queryValues.childId = childId;
        
        const queryValueString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValueString}`);
    };

    const handleSearch = async searchTerm => {
        setSearchTerm(searchTerm);
    };

    const handleCreateSystem = () => {
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=d0f113f5-32e1-4e2c-bf4d-386edb7f9bc4&company=${activeNavCompany.id}&entityType=system&client=${activeNavClient.id}&site=${activeNavSite.id}&parentId=33ba6af0-1e7a-4fcf-b75b-f355a01a962b`,
                state:    { 'returnUrl': `/v2/dashboard/site?appId=${bob.key}&childId=13dfff21-071c-4ee6-ab53-903fdcb5996a&client=${activeNavClient.id}&company=${activeNavCompany.id}&parentId=c0c505f5-c7fc-4317-8cb6-f6e631142a77&site=${activeNavSite.id}` }
            })
            :
            handleToggleCreateEquipmentModal(true);
    };

    const handleCreateEquipment = () => {
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=7035ee2f-b8ee-48ee-a9ac-ac522917dcdd&company=${activeNavCompany.id}&entityType=equipment&client=${activeNavClient.id}&site=${activeNavSite.id}&parentId=33ba6af0-1e7a-4fcf-b75b-f355a01a962b`,
                state:    { 'returnUrl': `/v2/dashboard/site?appId=${bob.key}&childId=bb5be75b-d466-48d5-99da-79cd66504f20&client=${activeNavClient.id}&company=${activeNavCompany.id}&parentId=c0c505f5-c7fc-4317-8cb6-f6e631142a77&site=${activeNavSite.id}` }
            })
            :
            handleToggleCreateEquipmentModal(true);
    };

    const handleCreateContact = () => {
        const queryValues = queryString.parse(history.location.search);
        const queryValuesString = queryString.stringify(queryValues);
        history.push(`/v2/dashboard/contacts?${queryValuesString}`);
    };

    const handleDeleteContacts = async () => {
        if (isEmpty(contactTableSelectState)) return;

        let filteredContactState = { ...contactTableSelectState };

        for (var key in filteredContactState) {
            if (filteredContactState[key] === false) {
                delete filteredContactState[key];
            }
        }

        const ids = Object.keys(filteredContactState);

        if (ids) {
            await bulkDeleteContact(ids);
            await fetchSiteContacts(activeNavClient.id, activeNavSite.id);
            setContactTableSelectState({});
        }
    };

    const refreshGrid = () => {
        if (activeNavSite.id) { 
            const weatherOptions = {siteId: activeNavSite.id};
            fetchCurrentWeatherData(weatherOptions);
        }
        setRefreshTab(activeTab);
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    const handleContactExport = () => {
        const options = _contactExport.current.workbookOptions();
        const rows = options.sheets[0].rows;

        rows.forEach((row, index) => {
            if (row.type === 'data') {
                const nameCell = row.cells[0];
                const primaryCell = row.cells[3];
                const smsCell = row.cells[4];
                const numbers = _contactExport.current.props.data[index - 1].userAssignmentPhones;

                const name = _contactExport.current.props.data[index - 1].userName;
                const primary = numbers.find(item => item.isPrimary === true);
                const sms = numbers.find(item => item.isSMS === true);

                nameCell.value = name.FirstName + ' ' + name.LastName;
                primaryCell.value = primary ? primary.phoneNumber.number : null;
                smsCell.value = sms ? sms.phoneNumber.number : null;
            }
        });

        if (_contactExport.current !== null) {
            _contactExport.current.save(options);
        }
    };

    return (
        <div className={classes.TableContainer}>
            {
                activeTab === 'Equipment' || activeTab === 'System' || activeTab === 'Faults' || activeTab === 'Health Monitor' || activeTab === 'Contact' ?
                    <div className={classes.TableContainerHead}>
                        <div className={classes.SelectContainer}>
                            <TabViewSelector
                                overviewPage={'site'}
                                activeTab={activeTab}
                                handleChangeView={handleChangetabView}
                            />
                        </div>
                        {activeTab === 'Health Monitor' ?
                            <div className={classes.SearchContainer}>
                                <SearchInput
                                    key={new Date()}
                                    className={classes.SearchInput}
                                    search={debounce(handleSearch, 700)}
                                    placeholder={`Search by ${activeTab === 'Health Monitor' ? 'Rule' : activeTab} Name`}
                                    value={searchTerm}
                                />
                            </div>
                            : null}
                        <div className={classes.TotalsContainer}>
                            {
                                activeTab === 'Equipment' || activeTab === 'System' || activeTab === 'Faults' || activeTab === 'Contact' ?
                                    <div className={activeTab === 'Contact' ? classes.ContactWorkbookMode : classes.WorkbookModeContainer}>
                                        <BobWorkbookModeButton
                                            handleWorkbookMode={handleWorkbookMode}
                                            workbookMode={workbookModeEnabled}
                                        />
                                    </div>
                                    :
                                    null
                            }
                            {
                                activeTab === 'Faults' ?
                                    <TotalsPanel
                                        data={renderTotalsData(activeTab)}
                                        entityType={activeTab}
                                    />
                                    :
                                    <TotalsPanel
                                        data={renderTotalsData(activeTab)}
                                        entityType={`${activeTab}s`}
                                    />
                            }
                        </div>
                    </div>
                    : null
            }
            {
                activeTab !== 'Scoring' ?
                    <React.Fragment>
                        <div className={classes.FilterContainer}>
                            {renderChips(activeTab).map((item, index) => (
                                <FilterChip
                                    key={index}
                                    item={item}
                                    removeFilter={() => handleRemoveFilter(activeTab, item)}
                                />
                            ))}
                            { activeTab === 'Health Monitor' ? 
                                <BobFilterComponent
                                    data={renderSelectData(activeTab)}
                                    label={renderLabel(activeTab)}
                                    filterType={TABNAMES[activeTab]}
                                    activeFilters={renderActiveFilters(activeTab)}
                                    setFilters={handleSetFilter(activeTab)}
                                    showStatusFilter={ activeTab === 'Health Monitor' ? true : false}
                                />
                                : null}
                        </div>
                        {
                            activeTab !== 'Health Monitor' ?
                                null : 
                                <div
                                    className={classes.RefreshContainer}
                                    aria-hidden="true"
                                    role="button"
                                    tabIndex={0}
                                    onClick={refreshGrid}
                                >
                                    <span className="material-icons-outlined">refresh</span>
                                </div> 
                                
                        }
                        <div
                            className={classes.RefreshContainer}
                            aria-hidden="true"
                            role="button"
                            tabIndex={0}
                            onClick={refreshGrid}
                        >
                            <span className="material-icons-outlined">refresh</span>
                        </div>
                        <div className={classes.ActionButtonContainer}>
                            {
                                activeTab === 'Contact' ?
                                    <ContactsTableActionMenu
                                        handleCreateContact={handleCreateContact}
                                        handleDeleteContacts={handleDeleteContacts}
                                        handleContactExport={handleContactExport}
                                    />
                                    :
                                    <BobActionMenu
                                        isExport={activeTab !== 'Health Monitor' && activeTab !== 'Faults'}
                                        isExportTimeseries={activeTab !== 'Health Monitor' && activeTab !== 'Faults'}
                                        activeTab={`Site${ TABNAMES[activeTab] }`}
                                        handleExport={handleExport}
                                        handleHealthMonitorExport={handleHealthMonitorExport}
                                        handleExportTimeseries={handleExportTimeseries}
                                        handleCreateSite={() => handleToggleCreateEquipmentModal(true)}
                                        handleCreateEquipment={() => handleCreateEquipment()}
                                        handleCreateSystem={() => handleCreateSystem()}
                                        handlePreviewWeatherData={() => setPreviewWeatherDataModalOpen(true)}
                                        handleSubscribeToArea={() => setSubscribeToAreaModalOpen(true)}
                                        isHealthMonitor={activeTab === 'Health Monitor'}
                                        healthMonitorRawDataExport={healthMonitorRawDataExport}
                                        handleExportGrid={handleExcelExport}
                                    />
                            }
                        </div>
                    </React.Fragment>
                    :
                    null
            }
            <div className={classes.GridContainer}>
                { activeTab === 'Equipment' ?
                    <EquipmentTable
                        totalsData={renderTotalsData(activeTab)}
                        createEquipmentModalOpen={createEquipmentModalOpen}
                        deleteEquipmentModalOpen={deleteEquipmentModalOpen}
                        subscribeToAlertsEqquipmentModalOpen={subscribeToAlertsEqquipmentModalOpen}
                        handleToggleSubscribeToEquipmentAlertsModal={(value) => handleToggleSubscribeToEquipmentAlertsModal(value)}
                        handleToggleCreateEquipmentModal={(value) => handleToggleCreateEquipmentModal(value)}
                        handleToggleDeleteEquipmentModal={(value) => handleToggleDeleteEquipmentModal(value)}
                        refreshTab={refreshTab}
                        setRefreshTab={() => setRefreshTab('')}
                        setTableProps={setEquipmentTableProps}
                        searchTerm={searchTerm}
                        workbookModeEnabled={workbookModeEnabled}
                        exportSiteEquipment={exportSiteEquipment}
                        setExportSiteEquipment={setExportSiteEquipment}
                    />
                    : null
                }
                { activeTab === 'System' ?
                    <SystemsTable
                        totalsData={renderTotalsData(activeTab)}
                        isFromSystemTab={true}
                        createEquipmentModalOpen={createEquipmentModalOpen}
                        deleteSystemModalOpen={deleteSystemModalOpen}
                        subscribeToAlertsSystemsModalOpen={subscribeToAlertsSystemsModalOpen}
                        handleToggleSubscribeToSystemsAlertsModal={(value) => handleToggleSubscribeToSystemsAlertsModal(value)}
                        handleToggleCreateEquipmentModal={(value) => handleToggleCreateEquipmentModal(value)}
                        handleToggleDeleteSystemModal={(value) => handleToggleDeleteSystemModal(value)}
                        refreshTab={refreshTab}
                        setRefreshTab={() => setRefreshTab('')}
                        setTableProps={setSystemTableProps}
                        searchTerm={searchTerm}
                        workbookModeEnabled={workbookModeEnabled}
                    />
                    : null
                }
                {
                    activeTab === 'Faults' ?
                        <FaultsTable
                            workbookModeEnabled={workbookModeEnabled}
                            exportFaultView={exportFaultView}
                            setExportFaultView={setExportFaultView}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                        />
                        :
                        null
                }
                {
                    activeTab === 'Health Monitor' ?
                        <HealthMonitorTable
                            node={{type: 'site', id: activeNavSite.id}}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                            searchTerm={searchTerm}
                            healthMonitorFilters={healthMonitorFilters}
                            exportRef={_export}
                            setExportColumns={setExportColumns}
                            exportColumns={exportColumns}
                            setIsexportNodeHealthChecks={setIsexportNodeHealthChecks}
                            isexportNodeHealthChecks={isexportNodeHealthChecks}
                            subscribeToRuleAlertsModalOpen={subscribeToRuleAlertsModalOpen}
                            setSubscribeToRuleAlertsModalOpen={(value) => setSubscribeToRuleAlertsModalOpen(value)}
                        />
                        :
                        null
                }
                {
                    activeTab === 'Contact' ?
                        <ContactsTable
                            _contactExport={_contactExport}
                            refreshTab={refreshTab}
                            contactTableSelectState={contactTableSelectState}
                            setContactTableSelectState={setContactTableSelectState}
                            setRefreshTab={() => setRefreshTab('')}
                            view="site"
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        :
                        null
                }
                { activeTab === 'Scoring' ?
                    <ScoringPage
                        activeTab={activeTab}
                        handleSubscribeToArea={() => setSubscribeToAreaModalOpen(true)}
                        refreshTab={refreshTab}
                        setRefreshTab={() => setRefreshTab('')}
                    />
                    : null
                }
            </div>
            { isShowExportModal ?
                <BobModal
                    title={''}
                    isOnlyContent={true}
                >
                    <h3>Preparing Export</h3>
                </BobModal> : ''
            }
            {
                subscribeToAreaModalOpen ?
                    <CreateSubscriptionModal
                        parent={{ ...activeNavSite, siteId: activeNavSite.id, clientId: activeNavClient.id }}
                        parentLabel="Site"
                        type="area"
                        handleToggleSubscribeToAlertsModal={setSubscribeToAreaModalOpen}
                    />
                    :
                    null
            }
            {
                exportModalOpen ?
                    <ExportDataModal
                        entity={activeNavSite}
                        setExportModalOpen={setExportModalOpen} 
                        tabView={`Site${TABNAMES[activeTab]}`}
                        tableProps = { getActiveTabTableProps() }
                    /> : ''
            }
            {
                previewWeatherDataModalOpen ?
                    <PreviewWeatherDataModal
                        site={activeNavSite}
                        onClose={() => setPreviewWeatherDataModalOpen(false)}
                    />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:        state.bob.activeNavCompany,
        activeNavClient:         state.bob.activeNavClient,
        activeNavSite:           state.bob.activeNavSite,
        cardScores:              state.home.cardScores,
        dashboardEndTimeStamp:   state.dashboard.dashboardEndTimeStamp ? state.dashboard.dashboardEndTimeStamp.format() : null,
        dashboardStartTimeStamp: state.dashboard.dashboardStartTimeStamp ? state.dashboard.dashboardStartTimeStamp.format() : null,
        equipmentFilters:        state.dashboard.equipmentFilters,
        equipmentTypes:          state.equipmentTypes.data,
        healthMonitorFilters:    state.dashboard.healthMonitorFilters,
        issueTypes:              state.svcManagement.issueTypes,
        isShowExportModal:       state.dashboard.isShowExportModal,
        siteEquipment:           state.dashboard.siteEquipment,
        siteEquipmentMeta:       state.dashboard.siteEquipmentMeta,
        siteFaultSummaryMeta:    state.dashboard.siteFaultSummaryMeta,
        siteSystems:             state.dashboard.siteSystems,
        siteSystemsMeta:         state.dashboard.siteSystemsMeta,
        siteTabIndex:            state.dashboard.siteTabIndex,
        systemFilters:           state.dashboard.systemFilters,
        systemTypes:             state.systemTypes.data,
        workbookModeEnabled:     state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...ContactActions,
    ...DashboardActions,
    ...WeatherActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableContainer));
